import React from 'react';
import { IEventResultStore, eventDisciplineWrapper } from 'eTip--common';
import { translation } from 'easit--localization';

export interface IOtherEventResultsProps {
    graphicsPresentationId: number;
    otherResults: IEventResultStore[];
}

export const OtherEventResults = (props: IOtherEventResultsProps) => {
    const isBaseball = eventDisciplineWrapper.isBaseball(props.graphicsPresentationId);
    const isAmFootball = eventDisciplineWrapper.isAmFootball(props.graphicsPresentationId);

    const renderBaseballResult = (result: IEventResultStore) => {
        return result.isBaseballBase
            ? <span className={`icon-score icon-score-169-${result.score1}`}></span>
            : <span>{result.score1}</span>
    }

    if ((isBaseball || isAmFootball) && props.otherResults && props.otherResults.length) {
        return <div className="d-flex results-wrapper other-results-wrapper">
            {
                isBaseball &&
                <div className="other-results-label">{translation().live_BaseballCurrentHalfInningStat}</div>
            }
            {
                isAmFootball &&
                <div className="other-results-label">{translation().live_AmFootballAttackTeamStat}</div>
            }
            {
                props.otherResults.map(result => <div key={result.iconId} className="d-flex flex-column text-center">
                    <div className="results-header"><span className={`icon-score icon-score-${result.iconId}`}></span></div>
                    <div>{
                        isBaseball ? renderBaseballResult(result) : <span>{result.score1}</span>
                    }</div>
                </div>)
            }
        </div>
    }
    else {
        return null;
    }
}